type NavigationState = {
  collapsedPath?: string;
};

export const messageNavigationState: NavigationState = {};
